export default __webpack_public_path__ + "static/nosotras-b9cde94b725b05081ad57993b3b67f2a.png";